import links from './links';

const tooltips = {
  company: 'Seaoil or Affiliate company.  The legal entity liable for the transaction.',

  payee: `The supplier, vendor or individual.  The legal entity or name of individual the company is liable to.
  If the payee is not on the list, you may need to undergo the vendor enrollment process <a href="${links.vendorRequestForm}" target="_blank">here</a>`,

  billingPeriod: `Covered period of the liability (e.g. September 1 - September 30, 2020), 
  if not applicable please choose the current date.`,

  datePayable: 'Due date or expected date of payment.',

  modeOfPayment: `Manner of payment or how payment is expected to be made. 
  Any special instructions must be indicated in the "PARTICULARS" field.`,

  category: 'High level category of the transaction the company is liable for.',

  subcategory1: 'Sublevel category of the category the company is laible for.',

  subcategory2: 'Sublevel category of the category the company is laible for.',

  costCenter: `The company's Department or Department's Sub-unit to which the costs are to be charged to. 
  If to be charged to a cost center different from your own, addl confirmation from the cost center owner must be 
  secured.`,

  project: `The company's Project Name to which the costs are to be charged to.  If not applicable, please choose default. 
  If Project Name is not on the list, please email the details to: nyrah_beltijar@seaoil.com.ph`,

  location: `The applicable location for the transaction. 
  If multiple location, please choose your base location as requester.`,

  product: `The applicable SEAOIL PRODUCT for the transaction.
  If multiple product or product is not applicable, please choose DEFAULT.`,

  referenceNo: 'Reference No. of the primary document for the transaction (e.g. INV#123, BILL#45)',

  attachment: 'Copy of supporting documents of the transaction.',

  particulars: 'Complete description of the transaction.',
};

export default tooltips;
